// Theme: velvet-void
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'velvet-void',
  name: 'VELVET VOID',
  tagline: 'VELVET VOID',
  description: 'Roxo veludo profundo em escuridao de luxo.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0A0515', '#150A28', '#9333EA', '#F3E8FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-velvet-void'
  },
  colorVars: {
    '--accent': '#9333EA',
    '--accent-foreground': '#0A0515',
    '--background': '#0A0515',
    '--border': '#5A2A8A',
    '--card': '#150A28',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3E8FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0515',
    '--foreground': '#F3E8FF',
    '--hold-fill': '#9333EA',
    '--input': '#5A2A8A',
    '--modal-bg': '#0A0515',
    '--modal-border': '#5A2A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#5A2A8A',
    '--muted-foreground': '#F3E8FF',
    '--nav-active': '#9333EA',
    '--nav-bg': '#150A28',
    '--popover': '#150A28',
    '--popover-foreground': '#F3E8FF',
    '--primary': '#9333EA',
    '--primary-foreground': '#0A0515',
    '--ring': '#9333EA',
    '--secondary': '#5A2A8A',
    '--secondary-foreground': '#F3E8FF',
    '--streak': '#9333EA',
    '--success': '#22c55e',
    '--success-foreground': '#0A0515',
    '--xp': '#9333EA',
    '--xp-bg': '#150A28'
  },
  resolvedVars: {
    '--accent': '#9333EA',
    '--accent-foreground': '#0A0515',
    '--accent-foreground-hsl': '259 62% 5%',
    '--accent-foreground-oklch': 'from #0A0515 l c h',
    '--accent-hsl': '271 81% 56%',
    '--accent-oklch': 'from #9333EA l c h',
    '--background': '#0A0515',
    '--background-hsl': '259 62% 5%',
    '--background-oklch': 'from #0A0515 l c h',
    '--border': '#5A2A8A',
    '--border-hsl': '270 53% 35%',
    '--border-oklch': 'from #5A2A8A l c h',
    '--border-w': '1px',
    '--card': '#150A28',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3E8FF',
    '--card-foreground-hsl': '269 100% 95%',
    '--card-foreground-oklch': 'from #F3E8FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '262 60% 10%',
    '--card-oklch': 'from #150A28 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0515',
    '--destructive-foreground-hsl': '259 62% 5%',
    '--destructive-foreground-oklch': 'from #0A0515 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F3E8FF',
    '--foreground-hsl': '269 100% 95%',
    '--foreground-oklch': 'from #F3E8FF l c h',
    '--hold-fill': '#9333EA',
    '--hold-fill-hsl': '271 81% 56%',
    '--hold-fill-oklch': 'from #9333EA l c h',
    '--input': '#5A2A8A',
    '--input-hsl': '270 53% 35%',
    '--input-oklch': 'from #5A2A8A l c h',
    '--modal-bg': '#0A0515',
    '--modal-bg-hsl': '259 62% 5%',
    '--modal-bg-oklch': 'from #0A0515 l c h',
    '--modal-border': '#5A2A8A',
    '--modal-border-hsl': '270 53% 35%',
    '--modal-border-oklch': 'from #5A2A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#5A2A8A',
    '--muted-foreground': '#F3E8FF',
    '--muted-foreground-hsl': '269 100% 95%',
    '--muted-foreground-oklch': 'from #F3E8FF l c h',
    '--muted-hsl': '270 53% 35%',
    '--muted-oklch': 'from #5A2A8A l c h',
    '--nav-active': '#9333EA',
    '--nav-active-hsl': '271 81% 56%',
    '--nav-active-oklch': 'from #9333EA l c h',
    '--nav-bg': '#150A28',
    '--nav-bg-hsl': '262 60% 10%',
    '--nav-bg-oklch': 'from #150A28 l c h',
    '--popover': '#150A28',
    '--popover-foreground': '#F3E8FF',
    '--popover-foreground-hsl': '269 100% 95%',
    '--popover-foreground-oklch': 'from #F3E8FF l c h',
    '--popover-hsl': '262 60% 10%',
    '--popover-oklch': 'from #150A28 l c h',
    '--primary': '#9333EA',
    '--primary-foreground': '#0A0515',
    '--primary-foreground-hsl': '259 62% 5%',
    '--primary-foreground-oklch': 'from #0A0515 l c h',
    '--primary-hsl': '271 81% 56%',
    '--primary-oklch': 'from #9333EA l c h',
    '--radius': '12px',
    '--ring': '#9333EA',
    '--ring-hsl': '271 81% 56%',
    '--ring-oklch': 'from #9333EA l c h',
    '--secondary': '#5A2A8A',
    '--secondary-foreground': '#F3E8FF',
    '--secondary-foreground-hsl': '269 100% 95%',
    '--secondary-foreground-oklch': 'from #F3E8FF l c h',
    '--secondary-hsl': '270 53% 35%',
    '--secondary-oklch': 'from #5A2A8A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#9333EA',
    '--streak-hsl': '271 81% 56%',
    '--streak-oklch': 'from #9333EA l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0515',
    '--success-foreground-hsl': '259 62% 5%',
    '--success-foreground-oklch': 'from #0A0515 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(271 81% 56% / 0.15)',
    '--xp': '#9333EA',
    '--xp-bg': '#150A28',
    '--xp-bg-hsl': '262 60% 10%',
    '--xp-bg-oklch': 'from #150A28 l c h',
    '--xp-hsl': '271 81% 56%',
    '--xp-oklch': 'from #9333EA l c h'
  }
}
